import React from "react";
import { Box, styled, Typography } from "@mui/material";

const Frame = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  alignSelf: "stretch",
  gap: "12px",
}));

const Title = styled((props) => (
  <Typography variant="h5" {...props} />
))({
  color: "white",
});

const Body = styled((props) => (
  <Typography variant="body" {...props} />
))(({ theme }) => ({
  color: theme.vars.palette.base.background,
}));

const Text = (props) => {
  const { title, body, ...rest } = props;

  return (
    <Frame {...rest}>
      <Title>{title}</Title>
      <Body>{body}</Body>
    </Frame>
  );
};

export default Text;
export { Body };
